import {SurfaceReleaseDraftPage} from '../features/app-surfaces/surface-release-draft-page.tsx';
import {SurfaceReleaseReviewPage} from "../features/app-surfaces/surface-release-review-page.tsx";
import {SurfaceReleasePage} from "../features/app-surfaces/surface-release-page.tsx";
import {SurfaceListPage} from "../features/app-surfaces/surface-list-page.tsx";
import {SurfacePublishedPage} from "../features/app-surfaces/surface-published-page.tsx";
import { createBrowserRouter, Navigate } from "react-router";
import { AccountPage } from "../features/account/account-page.tsx";
import { BuildPage, HistoryPage, StructurePage } from "../features/builder/build-pages.tsx";
import { DataIndexPage, DataPage, RecordPage } from "../features/data/data-pages.tsx";
import { ProjectLayout } from "../features/project/project-layout.tsx";
import { ProjectMembersPage } from "../features/project-members/project-members-page.tsx";
import { LoginPage } from "../features/auth/login-page.tsx";
import { RegisterPage } from "../features/auth/register-page.tsx";
import { ForgotPasswordPage, ResetPasswordPage, VerifyEmailPage } from "../features/auth/token-pages.tsx";
import { OverviewPage } from "../features/home/overview-page.tsx";
import { AcceptInvitePage } from "../features/invite/accept-invite-page.tsx";
import { MembersPage } from "../features/members/members-page.tsx";
import { OrgUnitsPage } from "../features/org-units/org-units-page.tsx";
import { ProjectDetailPage, ProjectNewPage, ProjectsListPage } from "../features/projects/projects-pages.tsx";
import { OnboardingWorkspacePage, SelectWorkspacePage, WorkspaceSettingsPage } from "../features/workspace/workspace-pages.tsx";
import { AuthLayout } from "../layouts/auth-layout.tsx";
import { SurfaceDraftPage } from "../features/app-surfaces/surface-draft-page.tsx";
import { WorkPage } from "../features/work/work-page.tsx";
import { WorkspaceLayout } from "../layouts/workspace-layout.tsx";

// IA P0 (bảng « Kiến trúc thông tin »): /login … /invite/accept · /select-workspace · /onboarding/workspace ·
// /w/:workspaceId/{overview, projects, projects/new, projects/:id, team, org-units, settings} · /account.
// SAA-2026-008: /w/:ws/projects/:p/{data, data/:collectionKey, data/:collectionKey/:recordId, build, build/structure,
// build/history, members}.
export const routes = [
  { path: "/", element: <Navigate to="/select-workspace" replace /> },
  {
    element: <AuthLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/verify-email", element: <VerifyEmailPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
    ],
  },
  { path: "/invite/accept", element: <AcceptInvitePage /> },
  { path: "/select-workspace", element: <SelectWorkspacePage /> },
  { path: "/onboarding/workspace", element: <OnboardingWorkspacePage /> },
  { path: "/account", element: <AccountPage /> },
  {
    path: "/w/:workspaceId",
    element: <WorkspaceLayout />,
    children: [
      { index: true, element: <Navigate to="overview" replace /> },
      { path: "overview", element: <OverviewPage /> },
      { path: "work", element: <WorkPage /> },
      { path: "surfaces", element: <SurfaceListPage /> },
      { path: "surfaces/drafts/:draftId", element: <SurfaceDraftPage /> },
      { path: "surfaces/release-drafts/:draftId", element: <SurfaceReleaseDraftPage /> },
      { path: "surfaces/releases/preparations/:preparationId", element: <SurfaceReleaseReviewPage /> },
      { path: "surfaces/releases/:bindingId", element: <SurfaceReleasePage /> },
      { path: "surfaces/releases/:bindingId/versions/:revision", element: <SurfaceReleasePage /> },
      { path: "surfaces/releases/:bindingId/versions/:revision/screens/:screenId", element: <SurfaceReleasePage /> },
      { path: "surfaces/:bindingId", element: <SurfacePublishedPage /> },
          { path: "surfaces/:bindingId/versions/:surfaceId/:surfaceVersion", element: <SurfacePublishedPage /> },
      { path: "work/:requestId", element: <WorkPage /> },
      { path: "projects", element: <ProjectsListPage /> },
      { path: "projects/new", element: <ProjectNewPage /> },
      {
        // Khung project (IA.md « Menu cấp project »): Work = Tổng quan · Dữ liệu; Build = Bản thiết kế · Cấu trúc · Lịch sử.
        path: "projects/:projectId",
        element: <ProjectLayout />,
        children: [
          { index: true, element: <ProjectDetailPage /> },
          { path: "data", element: <DataIndexPage /> },
          { path: "data/:collectionKey", element: <DataPage /> },
          { path: "data/:collectionKey/:recordId", element: <RecordPage /> },
          { path: "build", element: <BuildPage /> },
          { path: "surfaces", element: <SurfaceListPage /> },
      { path: "surfaces/drafts/:draftId", element: <SurfaceDraftPage /> },
      { path: "surfaces/release-drafts/:draftId", element: <SurfaceReleaseDraftPage /> },
      { path: "surfaces/releases/preparations/:preparationId", element: <SurfaceReleaseReviewPage /> },
      { path: "surfaces/releases/:bindingId", element: <SurfaceReleasePage /> },
      { path: "surfaces/releases/:bindingId/versions/:revision", element: <SurfaceReleasePage /> },
      { path: "surfaces/releases/:bindingId/versions/:revision/screens/:screenId", element: <SurfaceReleasePage /> },
      { path: "surfaces/:bindingId", element: <SurfacePublishedPage /> },
          { path: "surfaces/:bindingId/versions/:surfaceId/:surfaceVersion", element: <SurfacePublishedPage /> },
          { path: "build/structure", element: <StructurePage /> },
          { path: "build/history", element: <HistoryPage /> },
          { path: "members", element: <ProjectMembersPage /> },
        ],
      },
      { path: "team", element: <MembersPage /> },
      { path: "org-units", element: <OrgUnitsPage /> },
      { path: "settings", element: <WorkspaceSettingsPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/select-workspace" replace /> },
];

export const createRouter = () => createBrowserRouter(routes);
